export const setDocumentTitle = (title: string): void => {
    document.title = `${title} | Bouygues Telecom`;
};

export const replaceWindowUrl = (url: string): void => {
    window.history.replaceState({}, '', url);
};
